import { CancelButton, ConfirmButton } from 'components/button/button.styled'
import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { FooterContainer, StyledDialog } from './useConfirmDialog.style'

interface ConfirmDialogProps {
    headerText?: string
    confirmMessage?: string
    redirectUrl?: string
}

export const useConfirmDialog = () => {
    const navigate = useNavigate()
    const [isVisible, setIsVisible] = useState(false)
    const [onConfirmCallback, setOnConfirmCallback] = useState<(() => void) | null>(null)
    const [dialogProps, setDialogProps] = useState<ConfirmDialogProps>({ headerText: '', confirmMessage: '', redirectUrl: undefined })

    const show = useCallback(
        (
            onConfirm: () => void,
            headerText: string = 'Művelet megerősítése',
            confirmMessage: string = 'Biztosan végre szeretné hajtani a mentést?',
            redirectUrl: string | undefined = undefined,
        ) => {
            setOnConfirmCallback(() => onConfirm)
            setDialogProps({ headerText, confirmMessage, redirectUrl })
            setIsVisible(true)
        },
        [],
    )

    const hide = useCallback(
        (redirect?: string) => {
            setIsVisible(false)
            if (redirect) navigate(redirect)
        },
        [navigate],
    )

    const onConfirm = useCallback(() => {
        if (onConfirmCallback) {
            onConfirmCallback()
            hide()
        }
    }, [onConfirmCallback, hide])

    const DialogComponent: React.FC = () => (
        <StyledDialog
            visible={isVisible}
            onHide={hide}
            header={dialogProps.headerText}
            footer={
                <FooterContainer>
                    <ConfirmButton label="Megerősítés" icon="pi pi-check" onClick={onConfirm} />
                    <CancelButton label="Mégsem" icon="pi pi-times" onClick={() => hide(dialogProps.redirectUrl)} />
                </FooterContainer>
            }
        >
            <div>{dialogProps.confirmMessage}</div>
        </StyledDialog>
    )

    return { show, hide, DialogComponent }
}
